export default __webpack_public_path__ + "static/HES-SO_INTERVIEWS_ANA-667df76ee95adbe22e8438d3f1e74134.jpg";